<template>
  <el-dialog
    width="1024px"
    top="50px"
    :title="'Sơ đồ quy trình'"
    :visible="visible"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <Workflow
      v-if="contractSteps.length > 0"
      :contract="contract"
      :current-step="currentStep"
      :contract-steps="contractSteps"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="medium"
        @click="handleClose"
      >
        Đóng
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Workflow from '../../../components/charts/Workflow.vue';

export default {
  name: "ContractWorkflowPopup",
  components: {
    Workflow
  },
  props: {
    visible: Boolean,
    contract: Object,
    contractTypeStatus: String
  },
  computed: {
    ...mapGetters("contract", ["allContractStatus", "allContractSteps", "allContractActions"]),
    contractSteps() {
      const result = this.allContractSteps.filter((s) => s.contract_id === this.contract.id)
      return result.sort((a, b) => a.order - b.order)
    },
    currentStep() {
      const step = this.contractSteps.find((s) => s.actions.find((a) => a.extra_data.to_state === this.contractTypeStatus));
      return this.contractSteps.find((s) => {
        if (step) {
          return s.order === step.order + 1
        }
        return s.order === 0
      })
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped></style>
